<template>
	<form @keydown="$event.key === 'Enter' ? save() : null">
		<div class="row">
			<div class="col-12 h1 text-white title mb-3 mb-md-1">
				<b>Iniciar sesión</b>
			</div>
			<div class="col-12">
				<InputText
					label="Email"
					:error="form.errors.get('email')"
					@change-value="(value) => (form.email = value)"
					:type="'email'"
				/>
			</div>
			<div class="col-12 mt-4">
				<InputPassword
					label="Contraseña"
					:error="form.errors.get('password')"
					:feedback="false"
					@change-value="(value) => (form.password = value)"
				/>
				<p
					@click="$parent.showForm = 'forgot'"
					class="text-primary cursor-pointer mt-2 mb-1"
				>
					¿Contraseña perdida?
				</p>
			</div>
			<div class="col-12 d-flex flex-column gap-3 mt-3 mt-md-4">
				<Button
					:disabled="form.busy"
					@click="save()"
					label="Iniciar sesión"
					class="bg-salmon w-100"
				/>
			</div>
		</div>
	</form>
</template>

<script>
	import Form from "vform";
	import { mapActions } from "vuex";

	export default {
		data: () => ({
			form: new Form(),
			showForgotPassword: false,
			showRegister: false,
		}),
		methods: {
			...mapActions(["login"]),
			save() {
				this.login({
					form: this.form,
					errors: this.form.errors,
				});
			},
		},
	};
</script>
